import { EDealType, EOfferType } from '../../types/recommendation';
import { TFavoriteDealType, TFavoriteEntityType } from './types';

export function mapFavoriteDealType(dealType: EDealType): TFavoriteDealType {
  return dealType === EDealType.Rent ? 'rent' : 'sale';
}

export function mapFavoriteEntityType(offerType: EOfferType): TFavoriteEntityType {
  switch (offerType) {
    case EOfferType.Commercial:
      return 'offerCommercial';
    case EOfferType.Newobject:
      return 'newbuilding';
    case EOfferType.Suburban:
      return 'offerSuburban';
    case EOfferType.Flat:
    default:
      return 'offerResidental';
  }
}
